import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ui/card.tsx';
import CountUp from 'react-countup';
import { DataBrickSkeleton } from '@r/components/kpi/skeleton/data-brick-skeleton.tsx';

export function getDataBrick(
  title: string | null = '', // Titre à afficher sur la carte.
  icon: ReactNode | null = null, // Icône à afficher sur la carte.
  value: number | string | null = null, // Valeur à afficher sur la carte.
  valueSuffix: string | null = null, // Suffixe à ajouter à la valeur.
  info: string | null = null, // Informations supplémentaires à afficher sur la carte.
  classname: string | null = null, // Classe CSS à ajouter à la carte.
  size: 'small' | 'large' = 'small', // Taille de la carte.
  decimals: 0 | 2 = 0 // Nombre de décimales à afficher.
) {
  if (value !== null) {
    const content = (
      <Card className="flex flex-col h-full">
        <CardHeader className="space-y-0">
          <CardTitle className="flex items-center space-x-2 text-xl font-author-complete font-regular">
            {icon && icon}
            {title && <div className="text-xl font-bold">{title}</div>}
          </CardTitle>
        </CardHeader>

        <CardContent className="flex flex-col font-regular">
          <div className="text-3xl font-bold text">
            {typeof value === 'number' ? (
              <CountUp
                className="font-bold"
                end={value}
                duration={2}
                suffix={valueSuffix ? valueSuffix : undefined}
                separator={' '}
                decimals={decimals}
              />
            ) : (
              value
            )}
          </div>
          {info && <div className="mt-2 text-sm font-light text-muted-foreground">{info}</div>}
        </CardContent>
      </Card>
    );

    const smallContainerCss = '2xl:h-full 2xl:w-6/12';
    const mainContainerCss = 'min-h-fit w-full';

    switch (size) {
      case 'small':
        return (
          <div className={`${mainContainerCss} ${smallContainerCss} ${classname}`}>{content}</div>
        );
      case 'large':
        return <div className={`${mainContainerCss} ${classname}`}>{content}</div>;
    }
  }
  return <DataBrickSkeleton size={size} />;
}
